import {DraggingStyle, NotDraggingStyle} from '@hello-pangea/dnd';
import {alpha, Theme} from '@mui/material/styles';
import {ThemeMode} from 'configs/themeConfig';
import {CSSProperties} from 'react';

export const getKanbanDragStyle = () => ({
    p: 2.5,
    px: 0,
    bgcolor: 'transparent',
    display: 'flex',
    overflow: 'auto',
});

export const getKanbanItemDragWrapper = (
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined,
    theme: Theme,
    isSelected?: boolean,
): CSSProperties | undefined => {
    const bgcolor = alpha(theme.palette.background.paper, 0.99);
    return {
        borderLeft: isSelected ? `4px solid ${theme.palette.primary.main}` : undefined,
        ...draggableStyle,
    };
};

export function getColumnDragWrapperStyle(
    isDragging: boolean,
    draggableStyle: DraggingStyle | NotDraggingStyle | undefined,
    theme: Theme,
    radius: string,
): CSSProperties | undefined {
    return {
        minWidth: 300,
        borderRadius: radius,
        userSelect: 'none',
        marginRight: 10,
        ...draggableStyle,
    };
}

export function getColumnDropWrapperStyle(isDraggingOver: boolean, theme: Theme, radius: string) {
    const bgcolor =
        theme.palette.mode === ThemeMode.DARK ? theme.palette.background.default : theme.palette.secondary[200];
    const bgcolorDrop =
        theme.palette.mode === ThemeMode.DARK
            ? theme.palette.text.disabled
            : alpha(theme.palette.secondary.light, 0.65);

    return {
        background: isDraggingOver ? bgcolorDrop : bgcolor,
        height: 'calc(100vh - 180px)',
        border: '1px solid',
        padding: '5px',
        borderColor: theme.palette.divider,
        borderRadius: radius,
        overflowY: 'auto',
        flex: 1,
        minHeight: 0,
    } as any;
}

export const kanbanCardHeights = [120, 100, 160, 80, 60];
